<body class="ltr leftmenu">
    <form autocomplete="off" novalidate [formGroup]="TentativeMasterForm">
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class="col-md-8 padding">
                                        <div class=" d-flex align-items-center pl-3">
                                            <img alt="Logo" src="../../assets/img/approval.png" class="mh-45px pb-2">
                                            <div class="">
                                                <h4 class="main-content-label mb-1"><b>
                                                    Tentative Exam Schedule 
                                                    </b></h4>
                                                <p class="text-muted card-sub-title mb-0">
                                                    Tentative Exam Schedule Data
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <hr class="mt-2 mb-2">
                                    <div class="row clearfix mt-3">
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>POE No</mat-label>
                                                        <input 
                                                            class="color" matInput formControlName="TsmCircularNumber"
                                                            placeholder="POE No" required>
                                                            <mat-error class="margin_tp"
                                                            *ngIf="TentativeMasterForm.controls['TsmCircularNumber'].touched && TentativeMasterForm.controls['TsmCircularNumber'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline"
                                                    class="example-full-width">
                                                    <mat-label>POE Date</mat-label>
                                                    <input class="color" matInput formControlName="TsmCircularDate"
                                                        [matDatepicker]="picker" placeholder="Date">
                                                    <mat-datepicker-toggle matSuffix
                                                        [for]="picker"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker></mat-datepicker>
                                                </mat-form-field>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Session</mat-label>
                                                        <mat-select #select232 placeholder="Session" class="colorblack"
                                                            formControlName="TsmSnNo" required>
                                                            <mat-select-filter *ngIf="select232.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                                [array]="sessionList"
                                                                (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of SessionFilterList"
                                                                [value]="item.SnNo">
                                                                {{item.SnName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="TentativeMasterForm.controls['TsmSnNo'].touched && TentativeMasterForm.controls['TsmSnNo'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Schedule Type
                                                        </mat-label>
                                                        <mat-select #select55 class="colorblack"
                                                            formControlName="TsmScheduleType" placeholder="Schedule Type" required>
                                                            <mat-select-filter *ngIf="select55.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                                [array]="TentativeScheduleList"
                                                                (filteredReturn)="filteredTentativeSchedule =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredTentativeSchedule"
                                                                [value]="item.CdCode">
                                                                {{item.CdDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="TentativeMasterForm.controls['TsmScheduleType'].touched && TentativeMasterForm.controls['TsmScheduleType'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Circular No</mat-label>
                                                        <input 
                                                            class="color" matInput formControlName="ReportCircularNo"
                                                            placeholder="Circular No">
                                                            <!-- <mat-error class="margin_tp"
                                                            *ngIf="TentativeMasterForm.controls['TsmCircularNumber'].touched && TentativeMasterForm.controls['TsmCircularNumber'].errors?.required">
                                                            Mandatory
                                                        </mat-error> -->
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <h6 class="mb-1 font"><b>
                                            *Note: This circular number will be displayed on Calender print report </b></h6>
                                        <div class="row col-sm-12">
                                            <div class="col-sm-10"></div>
                                            <div class="col-sm-2">
                                                <button type="button"
                                                    class="btn btn-primary btn-icon-text floatright mt-1 fr"
                                                    (click)="submit()">
                                                    <span style="display: flex; align-items: center;">
                                                        <img width="20vh" src="../../assets/img/save.gif"
                                                            style="margin-right: 5px;">
                                                        Save
                                                    </span>
                                                </button>
                                            </div>
                                            <hr class="mt-2 mb-2">
                                        </div>
                                           <div class="col-sm-9"></div>
                                            <div class="col-sm-3" [formGroup]="TentativeMasterForm">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                  <mat-label>{{'header.course-data.titleList.Search' | translate}}
                                                  </mat-label> <input class="color" matInput placeholder="Search" (keyup)="keypress()"
                                                  formControlName="SearchString">
                                                  <mat-icon matSuffix>search</mat-icon>
                                                </mat-form-field>
                                              </div>
                                        <!-- </div> -->
                                        <!-- <div class="col-sm-12"> -->
                                        <div class="table-responsive mt-4">
                                            <!-- <div class="container"> -->
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr class="">
                                                            <th class="f600  text-left" width="20%">
                                                                POE No
                                                            </th>
                                                            <th class="f600  text-left" width="20%">
                                                                 Date
                                                            </th>
                                                            <th class="f600  text-left" width="20%">
                                                                Session
                                                            </th>
                                                            <th class="f600  text-center" width="20%">
                                                                Schedule Type
                                                            </th>
                                                            <th class="f600  text-left" width="15%">
                                                                Circular No
                                                            </th>
                                                            <th class="f600 text-center" width="5%">
                                                                View
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody >
                                                        <tr *ngFor="let data of tsmlist;">
                                                            <td>
                                                                {{data.TsmCircularNumber}}
                                                            </td>
                                                            <td>
                                                                {{data.TsmCircularDate | date: 'dd/MM/yyyy'}}
                                                            </td>
                                                            <td>
                                                               {{data.SessionName}}
                                                            </td>

                                                            <td class="text-center">
                                                               {{data.SnName}}
                                                            </td>
                                                            
                                                            <td class="text-center">
                                                                {{data.ReportCircularNo}}
                                                             </td>
                                                            <td class="text-center" (click)="details(data)">
                                                                <i class="fa fa-eye eye"></i>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            <!-- </div> -->

                                        </div>

                                        <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                    (page)="onPageChange($event)"></mat-paginator>
                                        <!-- </div> -->

                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </form>
</body>